module.exports = __webpack_public_path__ + "img/ambassadorship.20bf0cfa.svg";